import { IntervalPrice } from "./intervalPrice";
import { ServiceConceptData } from "./serviceConceptData";

export class ServiceConcept {
  conceptServiceData: ServiceConceptData;
  intervalPrice: IntervalPrice[];
  debRepayment: DebRepayment[];
}

export class ConstractStudentDetails {
  contractDetailId: number;
  contractId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  priority: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class DebRepayment {
  debRepaymentId: number;
  serviceConceptId: number;
  debRepaymentDate: Date;
  cost: number;
  active: boolean;
}

export class UpdatedDebRepayment {
  debRepaymentId: number;
  month: number;
  year: number;
  cost: number;
  active: boolean;
}

export class DebRepaymentForm {
  debRepaymentId: number;
  serviceConceptId: number;
  debRepaymentDate: Date;
  cost: number;
  active: boolean;
}

export class DebRepaymentAddForm {
  serviceConceptId: number;
  startDate: Date;
  amount: number;
  feesNumber: number;
}

export class ContractDetailsAddForm {
  contractId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class ContractDetailAddRequest {
  contractId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class ContractDetailEditForm {
  contractDetailId: number;
  contractId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class ContractDetailEditRequest {
  contractDetailId: number;
  contractId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class UpdatedContractDetail {
  contractDetailId: number;
  sporadic: number;
  month: number;
  cycleId: number;
  isAmpa: number;
  scholarshipTypeId: number;
  advancePayment: number;
  advanceEnte: number;
  price: number;
  sporadicPrice: number;
  fee: number;
  advertisementDiscount: number;
  noAdvertisementDiscount: number;
  advertisementDiscountSchoolarship: number;
  noAdvertisementDiscountSchoolarship: number;
  justifiedDays: number;
  minimumDays: number;
  isSchoolarshipHolderSporadic: boolean;
  isProportionalFee: boolean;
  fixedFirstDiscount: number;
  fixedSecondDiscount: number;
  fixedThirdDiscount: number;
  fixedSchoolarshipDiscount: number;
}

export class DebRepaymentAddRequest {
  serviceConceptId: number;
  startYear: number;
  startMonth: number;
  amount: number;
  feesNumber: number;
}

export class DebRepaymentEditRequest {
  debRepaymentId: number;
  serviceConceptId: number;
  year: number;
  month: number;
  cost: number;
  active: boolean;
}

export class ContractIdResponse {
  value: number;
}

export class DeactivateServiceConceptRequest {
  conceptServiceId: number;
  contractId: number;
}
